import r from "styled-components";
import o from "../../utils/colors.js";
import { device as i } from "../../utils/device.js";
const p = r.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${o.red};

  @media ${i.isTablet} {
    padding-top: 34px;
    padding-bottom: 40px;
    padding-right: 1rem;
  }

  @media ${i.isMobile} {
    padding-bottom: 6px;
    flex-wrap: wrap;
    padding-right: 1rem;
  }
`;
export {
  p as Error,
  p as default
};
